<template>
    <div>
    <np-skeleton :type="'panel_only'" v-if="!objectIsNotEmpty(owners)"></np-skeleton>
    <form v-else @submit.prevent="submitPrevent" id="form" name="principals_form" autocomplete="off"
          ref="principals_form" class="content-inner formValidation">
        <np-input  :no-wrapper="true" :id="'section'" :name="'section'" :type="'hidden'" model-value="PRINCIPAL"></np-input>
        <div class="row">
            <div class="col-12">
                <div class="panel-sub-heading headingLarge" v-if="!is_reviewing">
                    <span class="h5 display-6 markedBottom bold">{{ isSoleTrader ? lang('sole_trader_principal') : lang('principals') }}</span>
                    <a v-if="!isSoleTrader" class="btn btn-sm btn-default btn-with-label excludeLink float-right float-end"
                       href="#" @click="addPrincipal" data-original-title=""
                       title=""><span class="btn-label"><i
                            class="fa fa-plus"></i></span>{{lang('add_principal')}}</a>
                </div>
            </div>
        <div class="col-12" v-if="is_reviewing">
            <a v-if="!isSoleTrader" class="btn btn-sm btn-default btn-with-label excludeLink float-right float-end"
                href="#"  @click="addPrincipal" data-original-title=""
               title=""><span class="btn-label"><i class="fa fa-plus"></i></span>{{lang('add_principal')}}</a>
        </div>
        <template v-if="owners.length > 0">
        <div class="col-12" v-for="(owner, index) in owners" :id="`accordion_${index}`">
            <div :id="`director_${index}`" :key="index" class="card" :class="index == 0 ? 'marginTop10' : ''">
                <div class="card-header cursorPointer" @click="toggleAccordionSection(owner)" :id="`heading_${index}`" data-bs-toggle="collapse" :data-bs-target="`#collapse_${index}`" aria-expanded="true" :aria-controls="`collapse_${index}`">
                    <h5 class="mb-0">
                        <span v-if="owner.is_open" class="caretSign rotate"><i class="fa fa-caret-up"></i></span>
                        <span v-else class="caretSign rotate"><i class="fa fa-caret-down"></i></span>
                        {{getPrincipalFullName(owner)}}
                        {{owner.ownership_perc !== '' ? owner.ownership_perc+'%' : ''}}
                        <span class="float-right float-end">
                            <!-- In Bootstrap 4 the class 'badge' was removed therefore 'badge badge-primary' wont work. -->
                            <!-- Was suggested to replace badge-primary with bg-primary -->
                             <span v-if="owner.is_bank_id_verified == '1'" class="badge bg-primary">{{ lang('verified') }}</span>
                             <button class="btn btn-warning btn-sm" type="button"
                                v-if="!isSoleTrader && index > 0"  @click="removePrincipal(index)">
                                <i class="fa fa-trash"></i>
                            </button>
                        </span>
                    </h5>
                </div>

                <div :id="`collapse_${index}`" :class="'collapse'" :data-owner_id="owner.owner_ref" :aria-labelledby="`heading_${index}`"
                     :data-bs-parent="`#accordion_${index}`">
                    <div class="card-body">
                        <bank-id-verify v-if="canUseBankIdVerify && owner.is_signatory == '1' && (user.email == owner.owner_email)"
                                         :acr-values-options="criiptoAcrValues"
                                         :parameters="parameters.PROVIDER_CONFIGS_PARAM.criipto"
                                         :application_reference="merchant.application_reference"
                                         :owner_ref="owner.owner_ref"
                                         :owner="owner"
                                         v-model="owner.verification_type"
                        ></bank-id-verify>
                        <div class="row">
                            <div class="col-lg-6 col-md-12 col-12" ref="block_personal_information">
                                <div class="row">
                                    <div class="col-12">
                                        <div class="panel-sub-heading headingSmall ">
                                            <span class="markedBottom">{{lang('personal_information')}}</span>
                                            <a v-if="canSearchPrincipal && !disableByBankId(owner)" class="btn btn-sm btn-default float-right float-end btn-with-label addTooltip excludeLink"
                                               :data-tooltip-text="lang('search_principal')" href="#"
                                               data-bs-target="#company-search-modal"
                                               data-bs-toggle="modal"
                                               @click="searchPersonnel(index)" data-original-title=""
                                               title="">
                                                <span class="btn-label"><i class="fa fa-search"></i></span>{{lang('search_principal')}}</a>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-12">
                                        <np-input
                                                :id="`owner_id_${index}`"
                                                :name="`owner_id[${index}]`"
                                                :label="'id'"
                                                :no-wrapper="true"
                                                :type="'hidden'"
                                                v-model="owner._id">
                                        </np-input>
                                        <div class="row" v-if="!isSoleTrader">
                                            <div class="col-md-6 col-12" v-show="checkSetMainPrincipal()">
                                                <np-checkbox
                                                        :id="`is_main_principal_${index}`"
                                                        :name="`is_main_principal[${index}]`"
                                                        ref="is_main_principal"
                                                        :required="!hasMainPrincipal"
                                                        @change="toggleMainPrincipal($event, index)"
                                                        :description="lang('is_main_principal')"
                                                        v-model="owner.is_main_principal"
                                                        :no-wrapper="true">
                                                </np-checkbox>
                                            </div>
                                            <div class="col-md-6 col-12">
                                                <np-checkbox
                                                        ref="is_signatory"
                                                        :id="`is_signatory_${index}`"
                                                        :name="`is_signatory[${index}]`"
                                                        :key="`is_signatory_${index}_${is_signatory_required}`"
                                                        @change="toggleSignatory($event, index, owner)"
                                                        :description="lang('is_signatory')"
                                                        :no-wrapper="true"
                                                        :required="is_signatory_required"
                                                        v-model="owner.is_signatory">
                                                </np-checkbox>
                                            </div>
<!--                                                <div class="col-md-6 col-12" v-show="showBeneficialOwner">-->
                                            <div class="col-md-6 col-12">
                                                <np-checkbox
                                                    ref="is_beneficial_owner"
                                                    :id="`is_beneficial_owner_${index}`"
                                                    :name="`is_beneficial_owner[${index}]`"
                                                    :key="`is_beneficial_owner_${index}_${is_beneficial_owner_required}`"
                                                    :description="lang('is_beneficial_owner')"
                                                    :no-wrapper="true"
                                                    @change="toggleBeneficialOwner($event, index)"
                                                    :required="is_beneficial_owner_required"
                                                    v-model="owner.is_beneficial_owner">
                                                </np-checkbox>
                                            </div>
                                            <div class="col-md-6 col-12">
                                                <np-checkbox
                                                        ref="is_responsible_party"
                                                        :id="`is_responsible_party_${index}`"
                                                        :name="`is_responsible_party[${index}]`"
                                                        :key="`is_responsible_party_${index}_${is_responsible_party_required}`"
                                                        :description="lang('is_responsible_party')"
                                                        :no-wrapper="true"
                                                        @change="toggleResponsibleParty($event, index)"
                                                        :required="is_responsible_party_required"
                                                        v-model="owner.is_responsible_party">
                                                </np-checkbox>
                                            </div>
                                            <div class="col-md-6 col-12" v-show="checkSetOwner(owner)">
                                                <np-checkbox
                                                    ref="is_owner"
                                                    :id="`is_owner_${index}`"
                                                    :name="`is_owner[${index}]`"
                                                    :description="lang('is_owner')"
                                                    :no-wrapper="true"
                                                    :required="!hasOwner"
                                                    v-model="owner.is_owner">
                                                </np-checkbox>
                                            </div>
                                            <div class="col-md-6 col-12">
                                                <np-checkbox
                                                    ref="is_director"
                                                    :id="`is_director_${index}`"
                                                    :name="`is_director[${index}]`"
                                                    :key="`is_director_${index}_${is_director_required}`"
                                                    :description="lang('is_director')"
                                                    :no-wrapper="true"
                                                    :disabled="isSoleTrader"
                                                    @change="toggleIsDirector($event, index)"
                                                    :required="is_director_required"
                                                    v-model="owner.is_director">
                                                </np-checkbox>
                                            </div>
                                        </div>
                                        <div class="row" >
                                            <div class="col-lg-7 col-md-8 col-sm-12">
                                                <np-radios
                                                        :id="`owner_title_${index}`"
                                                        :name="`owner_title[${index}]`"
                                                        :label="lang('field_title')"
                                                        :options="primeTitles"
                                                        :mode="'separate'"
                                                        ref="owner_title"
                                                        v-model="owner.owner_title">
                                                </np-radios>
                                            </div>
                                            <div class="col-lg-5 col-md-4 col-sm-12">
                                                <np-select2 v-show="owner.owner_title === 'other'"
                                                            :id="`other_owner_title_${index}`"
                                                            :name="`other_owner_title[${index}]`"
                                                            :placeholder="lang('field_title')"
                                                            :label="''"
                                                            :required="true"
                                                            ref="owner_title"
                                                            :parameters="otherTitles"
                                                            v-model="owner.other_owner_title">
                                                </np-select2>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-lg-6 col-md-6  col-12">
                                                <np-input
                                                        :id="`owner_first_name_${index}`"
                                                        :name="`owner_first_name[${index}]`"
                                                        ref="owner_first_name"
                                                        :label="lang('field_first_name')"
                                                        :rules="['alpha_name']"
                                                        :maxlength="getFirstNameMaxLengthByIso3('max')"
                                                        :disabled="disableByBankId(owner)"
                                                        :no-wrapper="false"
                                                        v-model="owner.owner_first_name">
                                                </np-input>
                                            </div>
                                            <div class="col-lg-6 col-md-6  col-12">
                                                <np-input
                                                        :id="`owner_second_name_${index}`"
                                                        :name="`owner_second_name[${index}]`"
                                                        ref="owner_second_name"
                                                        :label="lang('field_middle_name')"
                                                        :rules="['alpha_name']"
                                                        :maxlength="50"
                                                        :no-wrapper="false"
                                                        v-model="owner.owner_second_name">
                                                </np-input>
                                            </div>
                                            <div class="col-lg-6 col-md-6  col-12">
                                                <np-input
                                                        :id="`owner_surname_${index}`"
                                                        :name="`owner_surname[${index}]`"
                                                        ref="owner_surname"
                                                        :label="lang('owner_surname')"
                                                        :rules="['alpha_name']"
                                                        :maxlength="50"
                                                        :disabled="disableByBankId(owner)"
                                                        :no-wrapper="false"
                                                        v-model="owner.owner_surname">
                                                </np-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-6 col-12">
                                                <np-responsive  ref="contact_dob">
                                                    <template #label>
                                                    <span>{{ lang('date_of_birth') }}</span>
                                                    </template>
                                                    <template #input>
                                                    <div class="form-group input-group">
                                                        <div class="input-group-prepend">
                                                            <div class="input-group-text">
                                                                <i class="fa fa-calendar"></i>
                                                            </div>
                                                        </div>
                                                        <np-date-picker
                                                                :id="`contact_dob_${index}`"
                                                                :name="`contact_dob[${index}]`"
                                                                :placeholder="lang('contact_dob')"
                                                                :required="true"
                                                                class="form-control"
                                                                ref="contact_dob"
                                                                data-date-start-view="2"
                                                                :end-date="`-18y`"
                                                                :start-date="'01-01-1900'"
                                                                :disabled="disableByBankId(owner)"
                                                                @input="removeSlashes(owner.contact_dob, `${index}`, 'contact_dob') "
                                                                v-model="owner.contact_dob">
                                                        </np-date-picker>
                                                    </div>
                                                    </template>
                                                </np-responsive>
                                            </div>
                                            <div class="col-md-6 col-12">
                                                <np-select2
                                                        :id="`owner_nationality_${index}`"
                                                        :name="`owner_nationality[${index}]`"
                                                        ref="owner_nationality"
                                                        :mode="`country`"
                                                        :label="lang('field_nationality')"
                                                        :placeholder="lang('field_nationality')"
                                                        :parameters="nationality_params"
                                                        :no-wrapper="false"
                                                        :required="true"
                                                        v-model="owner.owner_nationality">
                                                </np-select2>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-6 col-12" v-if="!isSoleTrader">
                                                <np-input
                                                        :id="`ownership_perc_${index}`"
                                                        :name="`ownership_perc[${index}]`"
                                                        ref="ownership_perc"
                                                        :label="lang('field_owner_percentage')"
                                                        :no-wrapper="false"
                                                        :required="true"
                                                        :maxlength="3"
                                                        :addon-on-left="false"
                                                        autocomplete="off"
                                                        :readonly="isSoleTrader"
                                                        :rules="[{together_less_than_equal_n_percent_group: '', percent_group: 'principal', expected_total: expectedTotal.toString(), less_than_equal : expectedTotal}, 'numeric', 'is_natural']"
                                                        v-model="owner.ownership_perc">
                                                    <template #addon>
                                                    <span>%</span>
                                                    </template>
                                                </np-input>
                                            </div>
                                            <div class="col-md-6 col-12" v-if="principalIsPolishResident(owner)">
                                                <np-input
                                                    :id="`owner_pesel_${index}`"
                                                    :name="`owner_pesel[${index}]`"
                                                    ref="owner_pesel"
                                                    :label="lang('pesel')"
                                                    :rules="['is_natural', 'valid_pesel']"
                                                    :maxlength="11"
                                                    :minlength="11"
                                                    :check_config="false"
                                                    :required="true"
                                                    :no-wrapper="false"
                                                    v-model="owner.owner_pesel">
                                                </np-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-12 col-12">
                                                <np-radios
                                                    :label="lang('directional_ownership_type')"
                                                    :id="`directional_ownership_type_${index}`"
                                                    :name="`directional_ownership_type_[${index}]`"
                                                    ref="directional_ownership_type"
                                                    :required="false"
                                                    mode="co-join"
                                                    v-show="!isSoleTrader"
                                                    :options="parameters.COMPANY_OWNERSHIP_TYPE"
                                                    v-model="owner.directional_ownership_type">
                                                </np-radios>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-6 col-md-12 col-12 address_Panel" ref="block_current_address">
                                <div class="row">
                                    <div class="col-12">
                                        <div class="panel-sub-heading headingSmall ">
                                            <span class="markedBottom">
                                                    {{ lang('current_home_address') }}
                                            </span>
                                            <span
                                                v-if="!!getTooltipText('application_current_home_address')"
                                                data-bs-placement="right"
                                                data-container="body"
                                                data-bs-toggle="popover"
                                                :title="lang('current_home_address')"
                                                :data-popover-content="getTooltipText('application_current_home_address')"
                                                class="helpBtn addPopover helpHeader"
                                            >
                                                <i tabindex="-1" class="fa fa-info-circle"></i>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div class="row" :key="owner.contacts[0].country_code">
                                    <np-input
                                            :id="`contact_id_${index}`"
                                            :name="`contact_id_[${index}]`"
                                            :label="'id'"
                                            :no-wrapper="true"
                                            :type="'hidden'"
                                            v-model="owner.contacts[0].contact_id">
                                    </np-input>
                                    <div class="col-lg-4 col-md-4">
                                        <np-input
                                                :id="`owner_house_number_${index}`"
                                                :name="`owner_house_number[${index}]`"
                                                ref="house_number"
                                                :label="lang('building_number')"
                                                :rules="[{'alpha_numeric_slash': owner.contacts[0].country_code}]"
                                                :maxlength="20"
                                                :no-wrapper="false"
                                                :required="false"
                                                v-model="owner.contacts[0].house_number">
                                        </np-input>
                                    </div>
                                    <div class="col-lg-8 col-md-8">
                                        <np-postcode-search
                                                :id="`zip_code_${index}`"
                                                :name="`zip_code[${index}]`"
                                                :ref="`zip_code`"
                                                :label="lang('post_code')"
                                                :required="true"
                                                :rules="getPostCodeRules(['alpha_address_finder'], owner.contacts[0].country_code)"
                                                :minlength="getPostCodeFieldLengthByIso3(getIso3FromCountryCode(owner.contacts[0].country_code), 'min')"
                                                :maxlength="getPostCodeFieldLengthByIso3(getIso3FromCountryCode(owner.contacts[0].country_code), 'max')"
                                                :iso3=" getIso3FromCountryCode(owner.contacts[0].country_code) "
                                                :iso3_allowed_search="getAllowedIso3Search('principal_page')"
                                                v-model="owner.contacts[0].zip_code"
                                                :reference="merchantReference"
                                                @input="changedPostcode(owner.contacts[0])"
                                                @empty-address="allowPrincipalManualEdit($event, owner.contacts[0])"
                                                @address-selected="updateCompanyAddress($event, owner.contacts[0])">
                                        </np-postcode-search>
                                    </div>
                                    <div class="col-md-12 mt-3"
                                         v-if="owner.contacts[0].zip_code === '' && owner.contacts[0].street_line_1 === ''">
                                        <div class="card card--address--reminder">
                                            <div class="card-body">
                                                <span class="card-text">{{lang('please_search_postcode_for_details')}}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-12 mt-3" v-if="!owner.contacts[0].edit_address">
                                        <div class="" v-if="owner.contacts[0].street_line_1 !== ''">
                                            <div class="card card--address">
                                                <div class="card-body">
                                                <span class="card-text"
                                                      v-html="formatAddress(owner.contacts[0], true)"></span>
                                                </div>
                                            </div>
                                        </div>
                                        <button type="button" @click="editPrincipalAddress(owner.contacts[0])"
                                                class="btn btn-primary float-right float-end"> {{lang('enter_address_manually')}}
                                        </button>
                                    </div>
                                    <div class="col-12" v-show="owner.contacts[0].edit_address">
                                        <np-input
                                            :id="`flat_name_${index}`"
                                            :name="`flat_name[${index}]`"
                                            ref="flat_name"
                                            :label="lang('field_flat_name')"
                                            :rules="[{'alpha_numeric_space': owner.contacts[0].country_code}]"
                                            :no-wrapper="false"
                                            :required="false"
                                            :maxlength="50"
                                            v-model="owner.contacts[0].flat_name">
                                        </np-input>
                                        <np-input
                                                :id="`house_name_${index}`"
                                                :name="`house_name[${index}]`"
                                                ref="house_name"
                                                :label="lang('building_name')"
                                                :no-wrapper="false"
                                                :required="false"
                                                :maxlength="getHouseNameFieldLength('max')"
                                                v-model="owner.contacts[0].house_name">
                                        </np-input>
                                        <np-input
                                                :id="`street_line_1_${index}`"
                                                :name="`street_line_1[${index}]`"
                                                ref="street_line_1"
                                                :label="lang('field_street')"
                                                :rules="[{'alpha_space_dot': owner.contacts[0].country_code}]"
                                                :maxlength="getStreetNameFieldLength('max')"
                                                :no-wrapper="false"
                                                v-model="owner.contacts[0].street_line_1">
                                        </np-input>
                                        <np-input
                                                :id="`locality_${index}`"
                                                :name="`locality[${index}]`"
                                                ref="locality"
                                                :label="lang('field_locality')"
                                                :rules="[{'alpha_space_dot': owner.contacts[0].country_code}]"
                                                :maxlength="getLocalityFieldLength('max')"
                                                :no-wrapper="false"
                                                :required="false"
                                                v-country-dependent="[owner.contacts[0].country_code, 'locality']"
                                                v-model="owner.contacts[0].locality">
                                        </np-input>
                                        <np-input
                                                :id="`city_${index}`"
                                                :name="`city[${index}]`"
                                                ref="city"
                                                :label="lang('field_town_city')"
                                                :rules="[{'valid_city_town': owner.contacts[0].country_code}]"
                                                :no-wrapper="false"
                                                :maxlength="getCityFieldLength('max')"
                                                v-model="owner.contacts[0].city">
                                        </np-input>
                                        <div v-if="owner.contacts[0].country_code === '840'">
                                            <np-select2
                                                    ref="county_code"
                                                    :id="`county_code_${index}`"
                                                    :name="`county_code[${index}]`"
                                                    :label="lang('state')"
                                                    :parameters="parameters.STATES_PARAM"
                                                    :placeholder="lang('state')"
                                                    :no-wrapper="false"
                                                    v-country-dependent="[owner.contacts[0].country_code, 'county_code']"
                                                    v-model="owner.contacts[0].county_code">
                                            </np-select2>
                                        </div>
                                        <div v-else>
                                            <np-input
                                                    ref="county_code"
                                                    :id="`county_code_${index}`"
                                                    :name="`county_code[${index}]`"
                                                    :label="lang('field_county_state')"
                                                    :rules="[{'alpha_space_dot': owner.contacts[0].country_code}]"
                                                    :no-wrapper="false"
                                                    v-country-dependent="[owner.contacts[0].country_code, 'county_code']"
                                                    v-model="owner.contacts[0].county_code">
                                            </np-input>
                                        </div>
                                        <np-select2
                                                :id="`country_code_${index}`"
                                                :name="`country_code[${index}]`"
                                                ref="country_code"
                                                :mode="`country`"
                                                :label="lang('country')"
                                                :placeholder="lang('country')"
                                                :parameters="parameters.COUNTRIES_PARAM"
                                                :no-wrapper="false"
                                                @input="resetPageConfig"
                                                v-model="owner.contacts[0].country_code">
                                        </np-select2>
                                    </div>
                                    <div class="col-12" v-show="hideLivedAtAddress">
                                        <np-responsive class="address_date_entry" ref="date_from">
                                            <template #label>
                                            <span>{{ lang('lived_at_this_since') }}</span>
                                            </template>
                                            <template #input>
                                            <div class="form-group input-group">
                                                <div class="input-group-prepend">
                                                    <div class="input-group-text">
                                                        <i class="fa fa-calendar"></i>
                                                    </div>
                                                </div>
                                                <np-date-picker ref="date_from"
                                                        :id="`date_from_${index}`"
                                                        :name="`date_from[${index}]`"
                                                        :placeholder="lang('date_format')"
                                                        class="form-control"
                                                        :start-date="owner.contact_dob"
                                                        :end-date="`-0d`"
                                                        :required="true"
                                                        @input="principalAddress(owner, index, 0, 'date_from')"
                                                        v-model="owner.contacts[0].date_from">
                                                </np-date-picker>
                                            </div>
                                            </template>
                                        </np-responsive>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-6 col-md-12 col-12 address_Panel" ref="block_finder_current_address">
                                <div class="row">
                                    <div class="col-12">
                                        <div class="panel-sub-heading headingSmall ">
                                            <span class="markedBottom">
                                                {{ lang('current_home_address') }}
                                            </span>
                                            <span
                                                v-if="!!getTooltipText('application_current_home_address')"
                                                data-bs-placement="right"
                                                data-container="body"
                                                data-bs-toggle="popover"
                                                :title="lang('current_home_address')"
                                                :data-popover-content="getTooltipText('application_current_home_address')"
                                                class="helpBtn addPopover helpHeader"
                                            >
                                                <i tabindex="-1" class="fa fa-info-circle"></i>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div class="row" :key="owner.contacts[0].country_code">
                                    <np-input
                                            :id="`finder_contact_id_${index}`"
                                            :name="`contact_id_[${index}]`"
                                            :label="'id'"
                                            :no-wrapper="true"
                                            :type="'hidden'"
                                            v-model="owner.contacts[0].contact_id">
                                    </np-input>
                                    <div class="col-lg-12 col-md-12">
                                        <np-postcode-search
                                                :id="`address_finder`"
                                                :name="`address_finder`"
                                                ref="address_finder"
                                                :label="lang('address_or_postcode_search')"
                                                :required="false"
                                                :rules="['alpha_address_finder']"
                                                :maxlength="50"
                                                :reference="merchantReference"
                                                :postcode_only="false"
                                                :iso3="getIso3FromCountryCode(owner.contacts[0].country_code)"
                                                :iso3_allowed_search="getAllowedIso3Search('principal_page')"
                                                :disable_if_no_search="true"
                                                v-model="owner.contacts[0].address_finder"
                                                @input="changedAddressFinderSearch(owner.contacts[0])"
                                                @empty-address="allowPrincipalManualEdit($event, owner.contacts[0])"
                                                @address-selected="updateCompanyAddress($event, owner.contacts[0], true)"
                                        ></np-postcode-search>
                                    </div>
                                    <div class="col-md-12 mt-3"
                                         v-if="owner.contacts[0].address_finder === '' && owner.contacts[0].street_line_1 === ''">
                                        <div class="card card--address--reminder">
                                            <div class="card-body">
                                                <span class="card-text">{{lang('please_search_postcode_or_address_for_details')}}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-12 mt-3" v-if="!owner.contacts[0].edit_address">
                                        <div class="" v-if="owner.contacts[0].street_line_1 !== ''">
                                            <div class="card card--address">
                                                <div class="card-body">
                                                <span class="card-text"
                                                      v-html="formatAddress(owner.contacts[0], true)"></span>
                                                </div>
                                            </div>
                                        </div>
                                        <button type="button" @click="editPrincipalAddress(owner.contacts[0])"
                                                class="btn btn-primary float-right float-end"> {{lang('enter_address_manually')}}
                                        </button>
                                    </div>
                                    <div class="col-12" v-show="owner.contacts[0].edit_address">
                                        <div class="row" v-for="address_row in getPrincipalAddressFinderStructureByIso3(getIso3FromCountryCode(allianceCountry))">
                                            <template v-for="address_field in address_row">
                                                <div :class="address_field[1]" v-if="address_field[0] === 'finder_flat_name'" ref="finder_flat_name">
                                                    <np-input
                                                            :id="`finder_flat_name_${index}`"
                                                            :name="`flat_name[${index}]`"
                                                            :label="lang('field_flat_name')"
                                                            :rules="[{'alpha_numeric_space': owner.contacts[0].country_code}]"
                                                            :no-wrapper="false"
                                                            :required="false"
                                                            :maxlength="50"
                                                            v-model="owner.contacts[0].flat_name">
                                                    </np-input>
                                                </div>
                                                <div :class="address_field[1]" v-if="address_field[0] === 'finder_house_number'">
                                                    <np-input
                                                            :id="`finder_owner_house_number_${index}`"
                                                            :name="`owner_house_number[${index}]`"
                                                            :label="getHouseNumberLabelFromCountryCode(allianceCountry)"
                                                            :rules="[{'alpha_numeric_slash': owner.contacts[0].country_code}]"
                                                            :maxlength="20"
                                                            ref="finder_house_number"
                                                            :no-wrapper="false"
                                                            :required="false"
                                                            v-model="owner.contacts[0].house_number">
                                                    </np-input>
                                                </div>
                                                <div :class="address_field[1]" v-if="address_field[0] === 'finder_house_name'">
                                                    <np-input
                                                            :id="`finder_house_name_${index}`"
                                                            :name="`house_name[${index}]`"
                                                            :maxlength="getHouseNameFieldLength('max')"
                                                            :label="getHouseNameLabelFromCountryCode(allianceCountry)"
                                                            :no-wrapper="false"
                                                            :required="false"
                                                            ref="finder_house_name"
                                                            v-model="owner.contacts[0].house_name">
                                                    </np-input>
                                                </div>
                                                <div :class="address_field[1]" v-if="address_field[0] === 'finder_street_line_1'">
                                                    <np-input
                                                            :id="`finder_street_line_1_${index}`"
                                                            :name="`street_line_1[${index}]`"
                                                            :label="getStreetLabelFromCountryCode(allianceCountry)"
                                                            :rules="[{'alpha_space_dot': owner.contacts[0].country_code}]"
                                                            :maxlength="getStreetNameFieldLength('max')"
                                                            :no-wrapper="false"
                                                            ref="finder_street_line_1"
                                                            v-model="owner.contacts[0].street_line_1">
                                                    </np-input>
                                                </div>
                                                <div :class="address_field[1]" v-if="address_field[0] === 'finder_locality'" ref="finder_locality">
                                                    <np-input
                                                            :id="`finder_locality_${index}`"
                                                            :name="`locality[${index}]`"
                                                            :label="lang('field_locality')"
                                                            :rules="[{'alpha_space_dot': owner.contacts[0].country_code}]"
                                                            :maxlength="getLocalityFieldLength('max')"
                                                            :no-wrapper="false"
                                                            :required="false"
                                                            v-country-dependent="[owner.contacts[0].country_code, 'locality']"
                                                            v-model="owner.contacts[0].locality">
                                                    </np-input>
                                                </div>
                                                <div :class="address_field[1]" v-if="address_field[0] === 'finder_city'">
                                                    <np-input
                                                            :id="`finder_city_${index}`"
                                                            :name="`city[${index}]`"
                                                            :label="getCityLabelFromCountryCode(allianceCountry)"
                                                            :rules="[{'valid_city_town': owner.contacts[0].country_code}]"
                                                            :no-wrapper="false"
                                                            ref="finder_city"
                                                            :maxlength="getCityFieldLength('max')"
                                                            v-model="owner.contacts[0].city">
                                                    </np-input>
                                                </div>
                                                <div :class="address_field[1]" v-if="address_field[0] === 'finder_county_code'" ref="finder_county_code">
                                                    <np-select2
                                                            v-if="owner.contacts[0].country_code === '840'"
                                                            :id="`finder_county_code_${index}`"
                                                            :name="`county_code[${index}]`"
                                                            :label="lang('state')"
                                                            :parameters="parameters.STATES_PARAM"
                                                            :placeholder="lang('state')"
                                                            :no-wrapper="false"
                                                            v-country-dependent="[owner.contacts[0].country_code, 'county_code']"
                                                            v-model="owner.contacts[0].county_code">
                                                    </np-select2>
                                                    <np-input
                                                        v-else
                                                        :id="`finder_county_code_${index}`"
                                                        :name="`county_code[${index}]`"
                                                        :label="lang('field_county_state')"
                                                        :rules="[{'alpha_space_dot': owner.contacts[0].country_code}]"
                                                        :no-wrapper="false"
                                                        v-country-dependent="[owner.contacts[0].country_code, 'county_code']"
                                                        v-model="owner.contacts[0].county_code">
                                                    </np-input>
                                                </div>
                                                <div :class="address_field[1]" v-if="address_field[0] === 'finder_country_code'">
                                                    <np-select2
                                                            :id="`finder_country_code_${index}`"
                                                            :name="`country_code[${index}]`"
                                                            :mode="`country`"
                                                            :label="lang('country')"
                                                            :placeholder="lang('country')"
                                                            :parameters="parameters.COUNTRIES_PARAM"
                                                            :no-wrapper="false"
                                                            ref="finder_country_code"
                                                            @input="resetPageConfig"
                                                            v-model="owner.contacts[0].country_code">
                                                    </np-select2>
                                                </div>
                                                <div :class="address_field[1]" v-if="address_field[0] === 'finder_zip_code'">
                                                    <np-input
                                                            :id="`finder_zip_code`"
                                                            :name="`zip_code`"
                                                            :label="lang('post_code')"
                                                            :required="true"
                                                            :no-wrapper="false"
                                                            ref="finder_zip_code"
                                                            :rules="getPostCodeRules(['alpha_address_finder'], owner.contacts[0].country_code)"
                                                            :minlength="getPostCodeFieldLengthByIso3(getMerchantCountryCode(owner.contacts[0].country_code), 'min')"
                                                            :maxlength="getPostCodeFieldLengthByIso3(getMerchantCountryCode(owner.contacts[0].country_code), 'max')"
                                                            v-model="owner.contacts[0].zip_code"
                                                    ></np-input>
                                                </div>
                                                <div :class="address_field[1]" v-show="hideLivedAtAddress && address_field[0] === 'finder_date_from'">
                                                    <np-responsive class="address_date_entry" ref="finder_date_from">
                                                        <template #label>
                                                        <span>{{ lang('lived_at_this_since') }}</span>
                                                        </template>
                                                        <template #input>
                                                        <div class="form-group input-group">
                                                            <div class="input-group-prepend">
                                                                <div class="input-group-text">
                                                                    <i class="fa fa-calendar"></i>
                                                                </div>
                                                            </div>
                                                            <np-date-picker ref="finder_date_from"
                                                                            :id="`finder_date_from_${index}`"
                                                                            :name="`date_from[${index}]`"
                                                                            :placeholder="lang('date_format')"
                                                                            class="form-control"
                                                                            :start-date="owner.contact_dob"
                                                                            :end-date="`-0d`"
                                                                            :required="true"
                                                                            @input="principalAddress(owner, index, 0, 'date_from')"
                                                                            v-model="owner.contacts[0].date_from">
                                                            </np-date-picker>
                                                        </div>
                                                        </template>
                                                    </np-responsive>
                                                </div>
                                            </template>
                                        </div>

                                    </div>
                                </div>
                            </div>

                            <div class="col-12" ref="block_personal_information">
                                <div class="row">
                                    <div class="col-12">
                                        <div class="panel-sub-heading headingSmall "><span
                                                class="markedBottom">{{ lang('contact') }}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-6 col-12">
                                        <np-input
                                                :id="`email_address_${index}`"
                                                :name="`email_address[${index}]`"
                                                ref="owner_email"
                                                :label="lang('field_email')"
                                                :rules="['valid_email']"
                                                :maxlength="50"
                                                :no-wrapper="false"
                                                :required="owner.is_signatory === '1'"
                                                :check_config="false"
                                                v-model="owner.owner_email">
                                        </np-input>
                                        <np-notice v-if="owner.is_signatory ==='1' && isSoleTrader && !signatoryEmailMatchesUser(owner)" :notice="lang('signatory_principal_email_error')" :notice-class="'alert-warning'"></np-notice>
                                    </div>
                                    <div class="col-md-6 col-12">
                                        <div class="row compactInputFormat" ref="owner_phone">
                                            <div class="col-12">
                                                <label>{{lang('phone')}}</label>
                                            </div>
                                          <div class="input-group">
                                            <div class="col-5">
                                                <np-select2
                                                        :id="`owner_phone_code_${index}`"
                                                        :name="`owner_phone_code[${index}]`"
                                                        ref="owner_phone_code"
                                                        :no-wrapper="true"
                                                        :mode="`phone`"
                                                        :parameters="parameters.PHONE_CODES"
                                                        :required="owner.is_signatory === '1'"
                                                        :check_config="false"
                                                        v-model="owner.owner_phone_code">
                                                </np-select2>
                                            </div>
                                            <div class="col-7">
                                                <np-phone
                                                        :id="`owner_phone_no_${index}`"
                                                        :name="`owner_phone_no[${index}]`"
                                                        ref="owner_phone_no"
                                                        :no-wrapper="true"
                                                        :label="lang('phone_number')"
                                                        :rules="['numeric', 'phone_no_leading_zero']"
                                                        :maxlength=" getPhoneNoMaxLengthByIso3( getIso3FromPhoneCode( owner.owner_phone_code ) ) "
                                                        :minlength=" getPhoneNoMinLengthByIso3( getIso3FromPhoneCode( owner.owner_phone_code ) ) "
                                                        :phone-code="owner.owner_phone_code"
                                                        :required="owner.is_signatory === '1'"
                                                        :check_config="false"
                                                        v-model="owner.owner_phone_no">
                                                </np-phone>
                                            </div>
                                        </div>
                                      </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </template>
        <np-company-search ref="company-search"
                           :company-name="!!merchant.legal_name ? merchant.legal_name : quote.legal_name"
                           :registration-number="!!merchant.reg_number ? merchant.reg_number : quote.reg_number"
                           :vat-number="merchant.tax_id"
                           :business-type="canUseVatToSearchBusiness ? merchant.ownership_entity_type : null"
                           :search_transparent_data="canUseVatToSearchBusiness"
                           :search_bisnode_data="isBisNodeSearch"
                           :country_code="baseCountryCode"
                           :country=" getIso3FromCountryCode( baseCountryCode ) "
                           :personnel="personnel_mode"
                           :reference="merchantReference"
                           :show_reg_num_options="isGermanAlliance"
                           @data="processPersonnelSearchData($event)">
        </np-company-search>
        </div>
        <div class="row mt-4" style="border-top: 1px solid #b2c6d0"  v-if="is_reviewing && isOpenApplication" >
            <div class="col-12">
                <div class="my-3">
                    <a class="btn btn-default" @click="savePrincipals"> {{lang('save')}}</a>
                </div>
            </div>
        </div>
        <div class="row mt-4" v-else-if="!is_reviewing" style="border-top: 1px solid #b2c6d0">
            <div class="col-12">
                <div class="my-3">
                    <button type="button" class="btn btn-danger me-1" @click="goBack"> {{lang('go_back')}}</button>
                    <button type="button" class="btn btn-default me-1" @click="doContinue"> {{lang('continue')}}</button>
                </div>
            </div>
        </div>
    </form>

        <div id="list-required-document-modal" class="modal" tabindex="-1" role="dialog" data-keyboard="false" data-backdrop="static">
            <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-body py-4 mt-4">
                        <div class="row">
                            <div class="col-md-4 col-12 pl-5 pt-5 mb-3">
                                <div class="text-center specific-blue-color rounded-circle d-flex align-content-center justify-content-center" style="width: 190px; height: 190px;">
                                    <img class="mx-auto my-auto" src="/assets/default/img/document_con.png" alt="document_con" style="width:60%;">
                                </div>
                            </div>
                            <div class="col-md-8 col-12 pe-4">
                                <div class="row">
                                    <div class="col-12">
                                        <span class="h5 display-6 bold black-text-color">{{ lang('list_required_document_header') }}</span>
                                    </div>
                                    <div class="col-12">
                                        <ul class="list-group mb-3 mt-3 black-text-color" id="list-require-documents">
                                            <li class="ms-3 mb-3" v-for="message in listRequireDocuments">
                                                {{message}}
                                            </li>
                                        </ul>
                                    </div>
                                    <div class="col-12">
                                        <span class="fw-bold black-text-color">{{ lang('document_upload_help_suffix') }}</span>
                                    </div>
                                    <div class="col-12 text-end mt-3 pe-5">
                                        <button type="button" id="go-next-list-document-modal" class="btn btn-required-document" data-bs-dismiss="modal" aria-label="Close">{{lang('list_required_document_button')}}</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import moment from 'moment';
    import {
        NPCheckBox,
        NPCompanySearch,
        NPDatePicker,
        NPInput,
        NPModal,
        NPNotice,
        NPPhone,
        NPPostcodeSearch,
        NPRadios,
        NPResponsive,
        NPSelect2,
        NPSkeleton,
        NPTextArea,
        NPVat
    } from "netpify/components";
    import {Owner} from "../../../entities";
    import applicationMixin from "../../../utils/application-mixin";
    import principalMixin from '../../../utils/principal-mixin.js';
    import documentMixin from '../../../utils/document-mixin.js';
    import navigationMixin from "../../../utils/navigation-mixin";
    import utilMixin from "../../../utils/mixins";
    import * as types from "../../../stores/constants";

    import BankIdVerify from "../../../components/bank-id-verify.vue";
    import {defaultCountry} from "../../../entities/default";
    import useModuleStore from "../../../stores";

    export default {
        name: "index",
        mixins:[utilMixin, applicationMixin, principalMixin, documentMixin, navigationMixin],
        components: {
            'np-modal': NPModal,
            'np-textarea': NPTextArea,
            'np-radios': NPRadios,
            'np-input': NPInput,
            'np-checkbox': NPCheckBox,
            'np-date-picker': NPDatePicker,
            'np-select2': NPSelect2,
            'np-company-search': NPCompanySearch,
            'np-postcode-search': NPPostcodeSearch,
            'np-responsive': NPResponsive,
            'np-vat': NPVat,
            'np-phone': NPPhone,
            'np-skeleton': NPSkeleton,
            'np-notice': NPNotice,
            'bank-id-verify': BankIdVerify
        },
        data() {
            return {
                current_index: '',
                personnel_mode: 2,
                page_config_template: 'SelfPrincipals',
                abortRouteLeave: false,
                principal_logic_config: [],
                principal_all_mandatory_roles: [],  //e.g. ['AS', 'D']
                principal_one_of_mandatory_roles: [],  //e.g. ['AS', 'D']
                application_all_mandatory_roles: [],  //e.g. ['AS', 'D']
                application_one_of_mandatory_roles: [],  //e.g. ['AS', 'D']
                ownership_percent_rules: [],  //e.g. ['GT' => '10', 'LE' => '70']
                is_signatory_required: false,
                is_responsible_party_required: false,
                is_director_required: false,
                is_beneficial_owner_required: false,
                principal_address_finder_structure: {
                    'SWE': [
                        [['finder_flat_name', 'col-lg-12 col-md-12']],
                        [['finder_street_line_1', 'col-lg-12 col-md-12']],
                        [['finder_house_number', 'col-lg-4 col-md-4'], ['finder_house_name', 'col-lg-8 col-md-8']],
                        [['finder_locality', 'col-lg-12 col-md-12']],
                        [['finder_zip_code', 'col-lg-12 col-md-12']],
                        [['finder_city', 'col-lg-12 col-md-12']],
                        [['finder_county_code', 'col-lg-12 col-md-12']],
                        [['finder_country_code', 'col-lg-12 col-md-12']],
                    ],
                    'NOR': [
                        [['finder_flat_name', 'col-lg-12 col-md-12']],
                        [['finder_street_line_1', 'col-lg-12 col-md-12']],
                        [['finder_house_number', 'col-lg-4 col-md-4'], ['finder_house_name', 'col-lg-8 col-md-8']],
                        [['finder_locality', 'col-lg-12 col-md-12']],
                        [['finder_zip_code', 'col-lg-12 col-md-12']],
                        [['finder_city', 'col-lg-12 col-md-12']],
                        [['finder_county_code', 'col-lg-12 col-md-12']],
                        [['finder_country_code', 'col-lg-12 col-md-12']],
                    ],
                    'DEU': [
                        [['finder_street_line_1', 'col-lg-8 col-md-8'], ['finder_house_number', 'col-lg-4 col-md-4']],
                        [['finder_zip_code', 'col-lg-8 col-md-8'], ['finder_city', 'col-lg-4 col-md-4']],
                        [['finder_country_code', 'col-lg-12 col-md-12']],
                    ],
                    default: [
                        [['finder_flat_name', 'col-lg-12 col-md-12']],
                        [['finder_house_number', 'col-lg-4 col-md-4'], ['finder_house_name', 'col-lg-8 col-md-8']],
                        [['finder_street_line_1', 'col-lg-12 col-md-12']],
                        [['finder_locality', 'col-lg-12 col-md-12']],
                        [['finder_city', 'col-lg-12 col-md-12']],
                        [['finder_county_code', 'col-lg-12 col-md-12']],
                        [['finder_country_code', 'col-lg-12 col-md-12']],
                        [['finder_zip_code', 'col-lg-12 col-md-12']],
                        [['finder_date_from', 'col-12']]
                    ]
                },
                showed_required_documents_list: false,
                max_principal_signatories_allowed: 7,
                allowed_iso3_search: {
                    default: ['DEU', 'DNK', 'IRL', 'FIN', 'GBR', 'NOR', 'POL', 'SWE'],
                    principal_page: ['GBR', 'DEU', 'POL', 'IRL', 'NOR', 'SWE']
                },
                nationality_params: [],
                owner_nationality_kee: 'owner_nationality',
            }
        },
        props: {
            is_reviewing: {
                default: false,
                type: Boolean,
            }
        },
        metaInfo() {
            return {
                title: this.lang('tab_principals')
            }
        },
        beforeRouteEnter: function (to, from, next) {
            let vm=this;
            next(vm => {
                vm.resetAccordionIcon();
                vm.showAccordion(0); //show the first one

                if (!vm.isOpenApplication) {
                    vm.$router.push({ path: `/application/view/${vm.$route.params.application_reference}/business_details/principals/`})
                }
                else if (vm.isPiiDataMaskedOwner && vm.$route.path.includes('/application/edit')) {
                    vm.$router.push({path: `/application/edit/${vm.$route.params.application_reference}/business_details/principals_mask/`});
                }

                if (vm.objectIsNotEmpty(vm.owners)) {
                    vm.owners.forEach(owner => {
                        if(owner.owner_title == '' || owner.owner_title == 'other') {
                            //do nothing
                        }else{
                            vm.setOtherTitle(owner, false, true)
                        }
                    })

                    //DEPRECATED - show all flags on the UI and let the User select by themselves
                    //set principal position and remove all other principals.
                    if (vm.isSoleTrader) {
                        vm.setSoleTraderPrincipal()
                    }
                }
            })
        },
        beforeRouteLeave(to, from, next) {
            // if(this.abortRouteLeave){
            //     next();
            //     return; //prevent it from doing anything else
            // }

            // Avoid save when UI is masked
            if (this.isPiiDataMaskedOwner) {
                next(true);
                return;
            }
            if (!this.checkDestinationRoute(to, from)) { //if user is going backwards, don't validate
                if (this.pageHasData() && !this.disable_go_back_warning_modal) {
                    this.alertBackRouteWarning((doCall = true) => next(doCall));
                } else {
                    next();
                    return;
                }
            } else {
                if (!this.isOpenApplication) {
                    next(true);
                } else {
                    if (to.fullPath.includes('/edit/')) {
                        // If open application do validate and save
                        this.savePrincipals(() => {
                            next();
                        }, to.fullPath);
                    } else {
                        next(true);
                    }
                }
            }
        },
        computed: {
            owners: function () {
                return this.merchant.owners;
            },
            showBeneficialOwner: function (){
                //everything but public limited
              return this.merchant.ownership_entity_type !== this.business_types.PUBLIC_LIMITED_COMPANY;
            },
            showResponsibleParty: function (){
                // only for limited
              return this.merchant.ownership_entity_type === this.business_types.LIMITED
            },
            allianceCountry: function() {
                return defaultCountry;
            },
            showDirector: function (){
              return !this.isSoleTrader && !this.isPartnership
            },
            hasBeneficialOwner: function () {
                return this.owners.some(owner => {
                    return owner['is_beneficial_owner'] === '1'
                });
            },
            expectedTotal: function () {
                //New logic: separates PrincipalOwnership from intermediary Ownership percentage
                return 100;

                // let total = 100;
                // if (this.merchant.has_intermediary_owner === '1') {
                //     this.merchant.intermediary_owners.forEach(obj => {
                //         total -= parseInt(obj['ownership_percentage']);
                //     });
                // }
                // return total;
            },
            hasSignatory: function () {
                return this.owners.some(owner => {
                    return owner['is_signatory'] === '1'
                })
            },
            hasOwner: function () {
                return this.owners.some(owner => {
                    return owner['is_owner'] === '1'
                })
            },
            hasMainPrincipal: function () {
                return this.owners.some(owner => {
                    return owner['is_main_principal'] === '1'
                })
            },
            hasDirector: function () {
                return this.owners.some(owner => {
                    return owner['is_director'] === '1'
                });
            },
            hasResponsibleParty: function () {
                return this.owners.some(owner => {
                    return owner['is_responsible_party'] === '1'
                })
            },
            canSearchPrincipal: function (){
                if (['616', '752', '578'].includes(this.baseCountryCode)) { //Poland, Sweden
                    return true;
                }
                return !this.isSoleTrader && !this.isPartnership;
            },
            principalLogicRolesOwnerRolesMapper: function() {
                let response = {};
                let dataMap = {
                    AUTHORISED_SIGNER: 'is_signatory',
                    BENEFICIAL_OWNER: 'is_beneficial_owner',
                    RESPONSIBLE_PARTY: 'is_responsible_party',
                    DIRECTOR: 'is_director',
                }

                Object.keys(dataMap).forEach(key => {
                    response[this.PRINCIPAL_ROLES[key]] = dataMap[key]
                })

                return response;
            },
            hideLivedAtAddress: function(){
                return false;
            },
            criiptoAcrValues: function (){
                if (!this.canUseBankIdVerify){
                    return []
                }

                if(this.parameters.hasOwnProperty('BANK_ID_VERIFICATION_ACR_VALUES') && this.parameters.BANK_ID_VERIFICATION_ACR_VALUES) {
                    return  Object.values(this.parameters.BANK_ID_VERIFICATION_ACR_VALUES);
                }
                return [];
            },
            intermediaryOwnershipSum: function () {
                let total = 0;
                if (this.merchant.has_intermediary_owner === '1') {
                    this.merchant.intermediary_owners.forEach(obj => {
                        total += parseInt(obj['ownership_percentage']);
                    });
                }
                return total;
            },
            principalOwnershipSum: function() {
                let total = 0

                if( !!this.merchant.owners && this.merchant.owners.length > 0 )
                {
                    this.merchant.owners.map(owner => {
                        total += parseInt( owner.ownership_perc )
                    })
                }

                return total
            },

        },
        mounted() {
            let vm = this;
            this.pageConfig = this.page_config[this.page_config_template];
            const country_params = this.getCountryCodeParams(this.app_default_param.ENTITY_BLOCK_BUSINESS,
                this.owner_nationality_kee);
            this.nationality_params = this.jsonCopy(country_params); // done to avoid mutation
            this.nationality_params.forEach(param => param.text = param?.nationality_country || param.text);

            vm.resetAccordionIcon(); //set all owner.is_open to false
            vm.showAccordion(0); //open first principal
            useModuleStore().commit(types.TOGGLE_LOADING, true);
            setTimeout(function () {
                vm.runPageConfig(vm.page_config[vm.page_config_template]);
                useModuleStore().commit(types.TOGGLE_LOADING, false);
                $("#form").formValidator({
                    // triggerElement: '', //trigger element default $('form').find('button[type="submit"]')
                    triggerEvent: '', // event - default 'click'
                    defaultConfig: '', // {} - object to set different configuration in validate.js
                    scrollToError: '', // enable auto-scroll to invalid element default true expect boolean
                    additionalCallbackFunction: '',
                });
            }, 1000);

            setTimeout(function (){
              if (vm.objectIsNotEmpty(vm.owners)) {
                vm.owners.forEach(owner => {
                  if (owner.owner_title == '' || owner.owner_title == 'other') {
                    //do nothing
                  } else {
                    vm.setOtherTitle(owner, false, true)
                  }
                })
              }
            }, 3000)
            vm.setIsSignatoryPrincipal();
            vm.setPrincipalLogicRules();
            if (vm.hasTenantAppDefaults) {
                vm.setPrincipalDefaultValues()
            }
        },
        created() {
            if (this.objectIsNotEmpty(this.merchant.owners[0]) && this.merchant.owners[0].owner_first_name === '') {
              this.merchant.owners[0] = this.opportunityPrincipalMap(this.merchant.owners[0])
            }
        },
        methods: {
            goBack: function (){
              this.abortRouteLeave = true;
              this.$router.push({path:  this.application_root_path +'business_details/trading/'})
            },
            doContinue: function (){
                let vm = this;

                let unfinished_application_exist = !!this.unfinished_application;
                let unfinished_application = unfinished_application_exist ? this.unfinished_application : null;

                //check if validation is needed and build next route
                vm.initDocumentValidationRulesByConfig();
                let needs_document_validation = Object.values(vm.document_categories_validation_rules).length > 0 || this.isIdPalWorkflowConfigured;

                let path_to = vm.application_root_path;
                if (unfinished_application && vm.isMerchantViewAndUpdateDocument(unfinished_application)) {
                    path_to += needs_document_validation ? 'upload_documents/' : 'review/';
                } else {
                    path_to += needs_document_validation ? 'documents/' : 'review/';
                }

                vm.$router.push({path: path_to});
            },
            // doContinueUploadDocuments: function (hide_modal = true) {
            //     let vm = this;
            //     let unfinished_application_exist = !!this.$parent.$parent && !!this.$parent.$parent.$parent && !!this.$parent.$parent.$parent.unfinished_application;
            //     let unfinished_application = unfinished_application_exist ? this.$parent.$parent.$parent.unfinished_application : null;
            //
            //     //check if validation is needed
            //     vm.initDocumentValidationRulesByConfig();
            //     let needs_document_validation = Object.values(vm.document_categories_validation_rules).length > 0 || this.isIdPalWorkflowConfigured;
            //
            //     let path_to = vm.application_root_path;
            //     if (unfinished_application && vm.isMerchantViewAndUpdateDocument(unfinished_application)) {
            //         path_to += needs_document_validation ? 'upload_documents/' : 'review/';
            //     } else {
            //         path_to += needs_document_validation ? 'documents/' : 'review/';
            //     }
            //
            //     if (hide_modal) {
            //         $('#list-required-document-modal').modal('hide');
            //     }
            //     vm.$router.push({path: path_to});
            // },
            pageHasData: function () {
              $('[id^=heading_]').removeClass('collapsed')
              $('[id^=collapse_]').addClass('show');
              return this.formHasValues($('#form'))
            },
            principalIsPolishResident: function (owner) {
              let is_polish_resident = owner.contacts[0].country_code === '616';

              if(!is_polish_resident){
                  owner.owner_pesel = '';
              }

              return is_polish_resident;
            },
            getPrincipalAddressFinderStructureByIso3: function (iso3) {
                if (this.principal_address_finder_structure.hasOwnProperty(iso3)) {
                    return this.principal_address_finder_structure[iso3];
                } else {
                    return this.principal_address_finder_structure.default;
                }
            },
            savePrincipals: function (callback = null, to_path = '') {
                let vm = this;
                //moved return to else block
                if (vm.validatePrincipal()) {
                    let payload = this.merchant.owners;
                    let form = this.getFormData($('#form'));
                    payload.section = 'PRINCIPAL';

                    vm[types.SAVE_MERCHANT](payload).then(response => {
                        if (response.data.result === 'SUCCESS') {
                            vm.notifySuccess(vm.lang('principals_updated_successfully'));
                            if (vm.is_reviewing) {
                              vm.$emit('close_review_section');
                            }
                            
                            if (Object.values(vm.document_categories_validation_rules).length > 0 && to_path.includes('documents')) {
                                //show document modal

                                // $('#list-required-document-modal').modal('show');
                                  let modalEl = document.querySelector('#list-required-document-modal')
                                  let modal = bootstrap.Modal.getOrCreateInstance(modalEl) // Returns a Bootstrap modal instance
                                  modal.show();
                                let promise = new Promise(function (resolve, reject) {
                                    //on close modal trigger call back.
                                    $('#list-required-document-modal').on('hidden.bs.modal', function () {
                                        resolve(true)
                                    })
                                }).then(resp => {
                                    if (!!resp && !!callback) { //call back is the next function in nav guard
                                        callback();
                                    }
                                })
                            } else {
                                if (!!callback) { //call back is the next function in nav guard
                                    callback();
                                }
                            }
                        }
                    }).catch(error => {
                        //console.log(error)
                    })
                } else {
                    return;
                }
            },
            getAcrValueLabel: function (acr_value) {
                let lang_key = types.BANK_ID_ACR_VALUES_PARAM[acr_value];

                if (!!lang_key) {
                    return this.lang(lang_key);

                }
                return '';
            },
            // verifyWithDocumentUpload: function ($event){
            //   this.merchant.verify_principal = '2' //document upload
            // },
            // verifyWithBankId: function (acr_value) {
            //     let vm = this;
            //     if (this.parameters.hasOwnProperty('PROVIDER_CONFIGS_PARAM') && this.parameters.PROVIDER_CONFIGS_PARAM.criipto) {
            //         let criipto_param = this.parameters.PROVIDER_CONFIGS_PARAM.criipto
            //         let application_reference = vm.merchant.application_reference;
            //
            //         let redirect_uri = site_url + 'application/bankidverify/';
            //         // let bank_id_verify_base_ulr = 'https://technologiworldwide-test.criipto.id/oauth2/authorize';
            //         let params = {
            //             'response_type': criipto_param.response_type,
            //             'response_mode':  criipto_param.response_mode,
            //             'client_id': criipto_param.client_id,
            //             'redirect_uri': redirect_uri,
            //             'acr_values': acr_value,  //'urn:grn:authn:no:bankid'
            //             'scope': 'openid',
            //             'state': application_reference,
            //         };
            //         let params_string = Object.keys(params).map(key => key + '=' + params[key]).join('&');
            //
            //         window.location.href = criipto_param.bank_id_authorise_url + '?' + params_string;
            //     }
            // },
            setPrincipalLogicRules: function () {
                let vm = this;
                vm.principal_logic_config = vm.getPrincipalLogicConfigByOwnershipType();
                vm.principal_all_mandatory_roles = vm.getRolesByRuleLevelAndCriteria(vm.principal_logic_config,
                    vm.PRINCIPAL_RULES.LEVEL_PRINCIPAL, vm.PRINCIPAL_RULES.CRITERIA_ALL_MANDATORY_ROLE);
                vm.principal_one_of_mandatory_roles = vm.getRolesByRuleLevelAndCriteria(vm.principal_logic_config,
                    vm.PRINCIPAL_RULES.LEVEL_PRINCIPAL, vm.PRINCIPAL_RULES.CRITERIA_ONE_OF_MANDATORY_ROLE);
                vm.application_all_mandatory_roles = vm.getRolesByRuleLevelAndCriteria(vm.principal_logic_config,
                    vm.PRINCIPAL_RULES.LEVEL_APPLICATION, vm.PRINCIPAL_RULES.CRITERIA_ALL_MANDATORY_ROLE);
                vm.application_one_of_mandatory_roles = vm.getRolesByRuleLevelAndCriteria(vm.principal_logic_config,
                    vm.PRINCIPAL_RULES.LEVEL_APPLICATION, vm.PRINCIPAL_RULES.CRITERIA_ONE_OF_MANDATORY_ROLE);
                vm.ownership_percent_rules = vm.getOwnershipPercentRule(vm.principal_logic_config,
                    vm.PRINCIPAL_RULES.LEVEL_PRINCIPAL);
                vm.is_signatory_required = vm.IsPrincipalRoleRequired(vm.PRINCIPAL_ROLES.AUTHORISED_SIGNER);
                vm.is_responsible_party_required = vm.IsPrincipalRoleRequired(vm.PRINCIPAL_ROLES.RESPONSIBLE_PARTY);
                vm.is_director_required = vm.IsPrincipalRoleRequired(vm.PRINCIPAL_ROLES.DIRECTOR);
                vm.is_beneficial_owner_required = vm.IsPrincipalRoleRequired(vm.PRINCIPAL_ROLES.BENEFICIAL_OWNER);
            },
            /**
             * @return {boolean}
             */
            IsPrincipalRoleRequired: function (principal_role) {
                let vm = this;
                if (!!vm.principal_all_mandatory_roles
                    && vm.principal_all_mandatory_roles.hasOwnProperty(principal_role)) {
                    return true;
                }

                if (!!vm.application_all_mandatory_roles) {
                    let role_field = vm.getOwnerFieldByRole(principal_role);  //get the principal role field of the owner
                    if (!!role_field) {
                        let has_selected = vm.owners.some(owner => owner.hasOwnProperty(role_field) && owner[role_field] === '1');
                        if (!has_selected && vm.application_all_mandatory_roles.includes(principal_role)) {
                            return true;
                        }
                    }
                }
                return false;
            },
            setIsSignatoryPrincipal: function (){
                let has_signatory = this.owners.find(obj => {return obj.is_signatory == '1'})

                if(!has_signatory){
                    this.owners[0].is_signatory = '1';
                }
            },
            validatePrincipal: function (){
                let vm = this;
                //open all accordions before validating. Accordions don't validate nicely when closed.
                $('[id^=heading_]').removeClass('collapsed')
                $('[id^=collapse_]').addClass('show');

                let form_is_valid = this.validateForm('#form');
                //new requirement separation of intermediary and principal ownership
                // if( ( this.intermediaryOwnershipSum + this.principalOwnershipSum ) > 100 )
                //     form_is_valid = false

                if(!form_is_valid) {
                    this.showErrorTooltip($('#principals_form').find('.has-error').first());
                }

                let owner_has_position = true, partnership_errors = [], validation_errors = [], position_errors = [];

                //full role validation by principal logic config
                validation_errors = vm.validateByPrincipalLogicConfig();

                if (this.partnershipBusinessTypes.includes(this.merchant.ownership_entity_type)) {
                    let has_sole_owner = this.merchant.owners.some(obj => {return parseFloat(obj.ownership_perc) === 100});
                    if (has_sole_owner) {
                        partnership_errors.push(this.lang('validation_partnership_business_with_100'));
                    }
                    let totalOwnershipPerc = 0;
                    this.merchant.owners.forEach(owner => {
                        totalOwnershipPerc += parseInt(owner.ownership_perc);
                    });

                    if (totalOwnershipPerc > this.expectedTotal) {
                        partnership_errors.push(this.lang('validation_ownership_percent_must_not_exceed') + this.expectedTotal + '%');
                    }

                    if (partnership_errors.length > 0) {
                        this.setHasErrorClassOnField(['ownership_perc_'])
                    }
                }

                //address type check
                let is_valid_address = true, address_errors =  [], dob_errors = [];
                this.merchant.owners.forEach((owner, index) => {
                    let fullname = this.getPrincipalFullName(owner)
                    if (!this.addressIsValid(owner.contacts[0])) {
                        is_valid_address = false;

                        if (this.countCharacters(owner.contacts[0].house_name) === 0 || this.countCharacters(owner.contacts[0].house_number) === 0) {
                            this.setHasErrorClassOnField(['house_name_' + index, 'house_number_' + index])

                            address_errors.push(`${this.lang('validation_house_name_number_is_required')} for ${this.lang('principal')} ${fullname}`)
                        }

                        address_errors.push(`${this.lang('validation_postcode_search')} for ${this.lang('principal')} ${fullname}`)
                    }

                    //dob check
                    let date_format = 'DD-MM-YYYY'
                    const date_format_mapping = {
                        ddmmyyyy: 'DD-MM-YYYY',
                        mmddyyyy: 'MM-DD-YYYY',
                        yyyymmdd: 'YYYY-MM-DD',
                    }

                    let tenant_format = $('body').attr('data-date-format')
                    let has_matched_data_format = !!tenant_format && !!date_format_mapping[tenant_format];
                    if (has_matched_data_format) {
                        date_format = date_format_mapping[tenant_format];
                    }

                    let dob_diff = moment().diff(moment(owner.contact_dob, date_format), 'years') > 17;
                    if (!dob_diff){
                      dob_errors.push(`${this.lang('principal')} ${fullname} ${this.lang('validation_principal_dob')}`)
                    }

                    //validate signatory owner email to match user email
                    if (owner.is_signatory === '1' && vm.isSoleTrader && !this.signatoryEmailMatchesUser(owner)) {
                      position_errors.push(`${this.lang('principal')} ${fullname} ${this.lang('validation_signatory_principal_email_error')}`)
                    }
                });

                let is_valid_signatory_email = this.merchant.owners.find(owner => {
                    return owner.is_signatory === '1' && vm.signatoryEmailMatchesUser(owner)
                })
                if (!is_valid_signatory_email) {
                    position_errors.push(`${this.lang('signatory_email_same_as_business_contact')}`);
                }

                // Name check
                let strArray = this.merchant.owners.map(own => {return `${own.owner_first_name} ${own.owner_second_name} ${own.owner_surname}`});
                let strEmailArray = this.merchant.owners.map(own => {return `${own.owner_email}`});
                let findDuplicates = arr => arr.filter((item, index) => item !== '' && arr.indexOf(item) != index) //first check prevents error on two empty email fields

                let duplicate_names = [...new Set(findDuplicates(strArray))]; // All duplicates
                let duplicate_emails = [...new Set(findDuplicates(strEmailArray))]; // All duplicates

                if (validation_errors.length > 0
                    || partnership_errors.length > 0
                    || address_errors.length > 0
                    || duplicate_names.length > 0
                    || duplicate_emails.length > 0
                    || dob_errors.length > 0
                    || position_errors.length > 0) {
                    let message = '';
                    let validation_start = validation_errors.slice(0, -2);
                    let validation_end = validation_errors.slice(-2);
                    if (validation_errors.length <= 2) {
                      message += validation_end.join(` ${this.lang('and')} `);
                    } else {
                      message += validation_start.join(`<br> `) + '<br> ';
                      message += validation_end.join(` <br> `);
                    }

                    if (address_errors.length > 0) {
                      address_errors.forEach(obj => {
                          this.notifyError(this.lang('validation_error'), obj);
                      })
                    }
                    if (dob_errors.length > 0) {
                      dob_errors.forEach(obj => {
                          this.notifyError(this.lang('validation_error'), obj);
                      })
                    }
                    if (position_errors.length > 0) {
                      position_errors.forEach(obj => {
                          this.notifyError(this.lang('validation_error'), obj);
                      })
                    }
                    if (duplicate_names.length > 0) {
                      this.notifyError(this.lang('validation_error'), `${this.lang('validate_duplicate_names')}: ${duplicate_names.join(', ')}`);
                    }
                    if (duplicate_emails.length > 0) {
                      this.notifyError(this.lang('validation_error'), `${this.lang('validate_duplicate_emails')}: ${duplicate_emails.join(', ')}`);
                    }
                    if (partnership_errors.length > 0) {
                      this.notifyError(this.lang('validation_error'), partnership_errors.join (' & '));
                    }
                    if (validation_errors.length > 0) {
                      this.notifyError(this.lang('validation_error'), message);
                    }

                    return false
                }

                return form_is_valid;
            },
            validateByPrincipalLogicConfig: function() {
                let vm = this;
                //Validating principals roles and percentage based on principal_logic_config
                let validation_errors = [];
                let temp_validation_errors;

                temp_validation_errors = vm.validatePrincipalsAllMandatoryRoles();
                validation_errors = validation_errors.concat(temp_validation_errors);

                temp_validation_errors = vm.validatePrincipalsOneOfMandatoryRole();
                validation_errors = validation_errors.concat(temp_validation_errors);

                temp_validation_errors = vm.validateApplicationAllMandatoryRole();
                validation_errors = validation_errors.concat(temp_validation_errors);

                temp_validation_errors = vm.validateApplicationOneOfMandatoryRole();
                validation_errors = validation_errors.concat(temp_validation_errors);

                temp_validation_errors = vm.validatePrincipalOwnershipPercentRules();
                validation_errors = validation_errors.concat(temp_validation_errors);

                return validation_errors;
            },
            validatePrincipalsAllMandatoryRoles : function() {
                let vm = this;
                let errors = [];
                //get configured mandatory roles for the principal
                let principal_all_mandatory_roles = vm.principal_all_mandatory_roles;
                if ((!Array.isArray(principal_all_mandatory_roles)) || (!Array.isArray(vm.merchant.owners))) {
                    console.log('Error! Invalid param or data', principal_all_mandatory_roles, vm.merchant.owners);
                    return errors;
                }
                if (principal_all_mandatory_roles.length === 0) {
                    return errors;
                }

                //check principals one by one
                vm.merchant.owners.forEach(owner => {
                    let owner_name = owner.owner_first_name + ' ' + owner.owner_surname;
                    principal_all_mandatory_roles.forEach(role => {
                        let role_field = vm.getOwnerFieldByRole(role);  //get the principal role field of the owner
                        if (role_field) {
                            let is_valid_owner = owner && owner.hasOwnProperty(role_field) && owner[role_field] === '1';
                            if (!is_valid_owner) { //the mandatory role was not being selected
                                let role_translation_text = this.getTranslationForPrincipalRoles(role);
                                let error_text = this.lang('principal_shall_have_role').replace('{0}', owner_name);
                                errors.push(error_text.replace('{1}', role_translation_text));
                            }
                        }
                    });
                });
                return errors;
            },
            validatePrincipalsOneOfMandatoryRole : function() {
                let vm = this;
                let errors = [];
                let principal_one_of_mandatory_roles = vm.principal_one_of_mandatory_roles;
                if ((!Array.isArray(principal_one_of_mandatory_roles)) || (!Array.isArray(vm.merchant.owners))
                    || (!vm.principalRoleToOwnerFieldMap)) {
                    console.log('Error!', principal_one_of_mandatory_roles, vm.merchant.owners, vm.principalRoleToOwnerFieldMap);
                    return errors;
                }
                if (principal_one_of_mandatory_roles.length === 0) {
                    return errors;
                }

                //check principals one by one
                vm.merchant.owners.forEach(owner => {
                    let one_of_mandatory_selected = false;
                    let owner_name = owner.owner_first_name + ' ' + owner.owner_surname;
                    principal_one_of_mandatory_roles.forEach(role => {
                        let role_field = vm.getOwnerFieldByRole(role);  //get the principal role field of the owner
                        if (role_field) {
                            let is_valid_owner = owner.hasOwnProperty(role_field) && (owner[role_field] === '1');
                            if (is_valid_owner) {
                                one_of_mandatory_selected = true;
                            }
                        }
                    });
                    if (!one_of_mandatory_selected) {
                        let role_translation_text = this.getTranslationForPrincipalRoles(principal_one_of_mandatory_roles);
                        let error_text = this.lang('principal_shall_have_one_of_roles').replace('{0}', owner_name);
                        errors.push(error_text.replace('{1}', role_translation_text));
                    }
                });
                return errors;
            },
            getApplicationPrincipalRolesCount: function() {
                let vm = this;
                let roles_count = {};
                if ((!Array.isArray(vm.merchant.owners)) || (!vm.principalRoleToOwnerFieldMap)) {
                    console.log('Error!', vm.merchant.owners, vm.principalRoleToOwnerFieldMap);
                    return roles_count;
                }
                Object.keys(vm.principalRoleToOwnerFieldMap).forEach(principal_role => {
                    roles_count[principal_role] = 0;
                });
                vm.merchant.owners.forEach(owner => {
                    Object.keys(vm.principalRoleToOwnerFieldMap).forEach(role_key => {
                        let owner_field = vm.principalRoleToOwnerFieldMap[role_key];
                        if (!!owner_field && owner.hasOwnProperty(owner_field) && (owner[owner_field] === '1')) {
                            roles_count[role_key] += 1;
                        }
                    });
                });
                return roles_count;
            },
            validateApplicationAllMandatoryRole : function() {
                let vm = this;
                let errors = [];
                let application_all_mandatory_roles = vm.application_all_mandatory_roles;
                if ((!Array.isArray(application_all_mandatory_roles)) || (!Array.isArray(vm.merchant.owners))
                    || (!vm.principalRoleToOwnerFieldMap)) {
                    console.log('Error!', application_all_mandatory_roles, vm.merchant.owners, vm.principalRoleToOwnerFieldMap);
                    return errors;
                }
                if (application_all_mandatory_roles.length === 0) {
                    return errors;
                }

                let principal_roles_count = this.getApplicationPrincipalRolesCount();
                application_all_mandatory_roles.forEach(role => {
                    if (!Object.keys(principal_roles_count).includes(role) || (principal_roles_count[role] === 0)) {
                        let role_translation_text = this.getTranslationForPrincipalRoles(role);
                        errors.push(this.lang('app_must_have_role').replace('{0}', role_translation_text));
                    }
                });
                return errors;
            },
            validateApplicationOneOfMandatoryRole : function() {
                let vm = this;
                let errors = [];
                let application_one_of_mandatory_roles = vm.application_one_of_mandatory_roles;
                if ((!Array.isArray(application_one_of_mandatory_roles)) || (!Array.isArray(vm.merchant.owners))
                    || (!vm.principalRoleToOwnerFieldMap)) {
                    console.log('Error!', application_one_of_mandatory_roles, vm.merchant.owners, vm.principalRoleToOwnerFieldMap);
                    return errors;
                }
                if (application_one_of_mandatory_roles.length === 0) {
                    return errors;
                }

                let keyed_principal_roles_count = this.getApplicationPrincipalRolesCount();
                let one_of_mandatory_selected = false;
                application_one_of_mandatory_roles.forEach(role => {
                    if (keyed_principal_roles_count.hasOwnProperty(role) && keyed_principal_roles_count[role] > 0) {
                        one_of_mandatory_selected = true;
                    }
                });

                if (!one_of_mandatory_selected) {
                    let role_translation_text = this.getTranslationForPrincipalRoles(application_one_of_mandatory_roles);
                    errors.push(this.lang('app_must_have_one_of_role').replace('{0}', role_translation_text));
                }
                return errors;
            },
            checkOwnershipPercentRule: function(ownerObj, rule) {
                let vm = this;
                let error = null;
                if (!ownerObj || !rule || (!vm.principalRoleToOwnerFieldMap)) {
                    console.log('Error!', ownerObj, rule, vm.principalRoleToOwnerFieldMap);
                    return error;
                }

                if (vm.principalRoleToOwnerFieldMap.hasOwnProperty(rule.principal_role)) {
                    let role_field = vm.principalRoleToOwnerFieldMap[rule.principal_role]; //get the principal role field of the owner
                    let is_valid_owner = ownerObj.hasOwnProperty(role_field) && (ownerObj[role_field] === '1');
                    if (!is_valid_owner) {
                        return error; //role was not selected, no need percentage validation
                    }

                    let ownership_percent = parseInt(ownerObj.ownership_perc);
                    let owner_name = vm.formatTitle(ownerObj.owner_title) + ' ' + ownerObj.owner_first_name + ' ' +
                        ownerObj.owner_surname;

                    let operation_code = rule['rule_criteria'];
                    let required_percentage = parseInt(rule['ownership_percentage']);
                    switch (operation_code) {
                        case vm.PRINCIPAL_RULES.CRITERIA_EQ:
                            if (ownership_percent !== required_percentage) {
                                error = owner_name + ': ' + vm.lang('ownership_perc_eq').replace('{0}', vm.formatPercent(required_percentage));
                            }
                            break;

                        case vm.PRINCIPAL_RULES.CRITERIA_GT:
                            if (ownership_percent <= required_percentage) {
                                error = owner_name + ': ' + vm.lang('ownership_perc_gt').replace('{0}', vm.formatPercent(required_percentage));
                            }
                            break;

                        case vm.PRINCIPAL_RULES.CRITERIA_GE:
                            if (ownership_percent < required_percentage) {
                                error = owner_name + ': ' + vm.lang('ownership_perc_gt_eq').replace('{0}', vm.formatPercent(required_percentage));
                            }
                            break;

                        case vm.PRINCIPAL_RULES.CRITERIA_LT:
                            if (ownership_percent >= required_percentage) {
                                error = owner_name + ': ' + vm.lang('ownership_perc_lt').replace('{0}', vm.formatPercent(required_percentage));
                            }
                            break;

                        case vm.PRINCIPAL_RULES.CRITERIA_LE:
                            if (ownership_percent > required_percentage) {
                                error = owner_name + ': ' + vm.lang('ownership_perc_lt_eq').replace('{0}', vm.formatPercent(required_percentage));
                            }
                            break;

                        default:
                            console.log('Error criteria', operation_code);
                            break;
                    }
                }
                return error;
            },
            validatePrincipalOwnershipPercentRules: function() {
                let vm = this;
                let errors = [];
                let temp_error;
                let ownership_percent_rules = vm.ownership_percent_rules;
                if ((!Array.isArray(ownership_percent_rules)) || (!Array.isArray(vm.merchant.owners))
                    || (!vm.principalRoleToOwnerFieldMap)) {
                    console.log('Error!', ownership_percent_rules, vm.merchant.owners, vm.principalRoleToOwnerFieldMap);
                    return errors;
                }

                vm.merchant.owners.forEach(owner => {
                    ownership_percent_rules.forEach(rule => {
                        temp_error = vm.checkOwnershipPercentRule(owner, rule);
                        if (temp_error) {
                            errors.push(temp_error);
                        }
                    });
                });
                return errors;
            },
            //     <button class="btn btn-warning btn-sm float-right float-end"
            // v-if="isPartnershipLLP && index > 1" @click="removePrincipal(index)">
            //     <i class="fa fa-trash"></i> h
            // </button>
            // <button class="btn btn-warning btn-sm float-right float-end"
            // v-else-if="!isSoleTrader && index > 0"  @click="removePrincipal(index)">
            //     <i class="fa fa-trash"></i>t
            // </button>
            //     in case you are ever confused why we have one button with two different logic
            //Logic 1. isPartnershipLLP && index > 1.  A partnership must be two people and over. So you can only delete from 3 principals
            //Logic 2. !isSoleTrader && index > 0.  Any one but sole trader can have more than one principal.
            setSoleTraderPrincipal: function (){
                //default all the sole proprietor flags
                this.owners[0].owner_position = 'OW';
                this.owners[0].is_main_principal = '1';
                this.owners[0].is_beneficial_owner = '1';
                this.owners[0].is_signatory = '1';
                this.owners[0].is_owner = '1';
                this.owners[0].is_director = '0';
                this.owners[0].is_responsible_party = '1';
                this.owners[0].ownership_perc = '100';
                this.owners[0].directional_ownership_type = this.DIRECTIONAL_OWNERSHIP_TYPE.DIRECT_OWNERSHIP;

                //delete all other principals except for the first.
                if (this.owners.length > 1) {
                    this.owners.splice(1, this.owners.length - 1);
                }
            },
            setPrincipalDefaultValues: function (field_name = 'owner_nationality') {
                if (!this.parameters.hasOwnProperty('TENANT_APP_DEFAULTS_PARAM')) {
                    return
                }
                const country_params = this.getCountryCodeParams(this.app_default_param.ENTITY_BLOCK_BUSINESS, this.owner_nationality_kee);
                this.nationality_params = this.jsonCopy(country_params); // done to avoid mutation
                this.nationality_params.forEach(param => param.text = param?.nationality_country || param.text);
                const default_owner_nationality = this.parameters.TENANT_APP_DEFAULTS_PARAM.find(f => f.field_name == field_name)
                if (default_owner_nationality && default_owner_nationality?.field_name) {
                    for (let ownersKey in this.merchant.owners) {
                        if (this.merchant.owners[ownersKey].owner_nationality == '') {
                            this.merchant.owners[ownersKey].owner_nationality = default_owner_nationality.selfboarding_default_value || '';
                        }
                    }
                }
            },
            ownerHasPosition: function (owner) {
                //owner must be signatory, beneficial owner or director
                return owner.is_signatory !== '1' && owner.is_beneficial_owner !== '1' && owner.is_director !== '1'
            },
            // ownerEmailRules: function (owner, index) {// tried to change the validation rules on the fly but didn't work.
            //       //console.log('called ownerEmailRules')
            //     if (owner.is_signatory === '1') {
            //         return ['valid_email', {value_same_as: this.user.email}]
            //     }
            //     return ['valid_email'];
            // },
            allowPrincipalManualEdit: function (data, addressObject = {}){
                addressObject.allow_manual_edit = true;
            },
            opportunityPrincipalMap: function (principal){

              // check if owner data has been set.
                let opportunity = this.merchant_user_access.opportunity.find(opp => {return opp.opportunity_external_id === this.quote.opportunity_external_id})
                const dataMap = {
                    //principal_fields: opportunity fields
                    owner_email: 'contact_email',
                    owner_first_name: 'contact_first_name',
                    owner_surname: 'contact_last_name',
                    owner_phone_code: 'contact_mobile_code',
                    owner_phone_no: 'contact_mobile_no',
                };
                const addressMap = {
                    zip_code : 'registered_address_post_code',
                    house_number : 'registered_address_building_no',
                    house_name : 'registered_address_building_name',
                    street_line_1 : 'registered_address_street',
                    city : 'registered_address_town_city',
                    country_code : 'registered_address_country_code',
                }

                if(!!opportunity && this.objectIsNotEmpty(opportunity)){
                    Object.keys(dataMap).forEach(key => {
                        if (opportunity.hasOwnProperty(dataMap[key])){
                            principal[key] = opportunity[dataMap[key]];
                        }
                    })

                    Object.keys(addressMap).forEach(key => {
                        if (opportunity.hasOwnProperty(addressMap[key])){
                            principal.contacts[0][key] = opportunity[addressMap[key]];
                        }
                    })
                }

                return principal;
            },
            addPrincipal: function () {
                let vm = this;
                this.owners.push(new Owner());

                setTimeout(function() {
                    vm.showAccordion(vm.owners.length - 1)
                    vm.runPageConfig(vm.page_config[vm.page_config_template]);
                    $("#form").formValidator({
                            // triggerElement: '', //trigger element default $('form').find('button[type="submit"]')
                            triggerEvent: '', // event - default 'click'
                            defaultConfig: '', // {} - object to set different configuration in validate.js
                            scrollToError: '', // enable auto-scroll to invalid element default true expect boolean
                            additionalCallbackFunction: '',
                        });
                    //     objCommon.general_radios_and_checkboxes($('#merchant-principal'));
                    //     objCommon.general_radios_and_checkboxes_deleg($('#merchant-principal'));
                    //
                    if (vm.hasTenantAppDefaults) {
                        vm.setPrincipalDefaultValues()
                    }
                }, 1000);
                // this.setApplicationSave();
            },
            removePrincipal: function (index) {
                const owner = this.owners[index]
                let can_remove_principal = this.checkPrincipalDocument(owner);
                if (can_remove_principal) {
                    this.owners.splice(index, 1);
                    this.setDefaultMainPrincipalIfNecessary();
                }
            },
            toggleMainPrincipal: function ($event, main_principal_index) {
                // //console.log($event);
                let vm = this;//, selected = this.owners[main_principal_index]['is_main_principal'] === '1';
                if ($event === '1') {
                    this.owners.forEach((obj, index) => {
                        if (index !== main_principal_index) {
                            vm.owners[index]['is_main_principal'] = '0';
                        }
                    })
                } else {
                    vm.setDefaultMainPrincipalIfNecessary()
                }

            },
            toggleSignatory: function ($event, signatory_index, owner) {
                // //console.log($event);
                let vm = this;//, selected = this.owners[signatory_index]['is_main_principal'] === '1';
                let principal_signatories_count = 0;

                if ($event === '1') {
                    this.owners.forEach((obj, index) => {
                        if (!vm.isSoleTrader && obj['is_signatory'] === '1') {
                            principal_signatories_count++;
                        } else {
                            vm.owners[index]['verification_type'] = '';
                        }
                        if (index !== signatory_index) {
                            if (vm.isSoleTrader) {
                                vm.owners[index]['is_signatory'] = '0';
                            }
                        }
                    })

                    if (!vm.isSoleTrader && principal_signatories_count > vm.max_principal_signatories_allowed) {
                        vm.notifyError(vm.lang('error'), vm.lang('principal_signatories_allowed'));
                    }
                    if(this.user.email !== owner.owner_email){
                        ////console.log('wrong');
                        // Signatory Principal must have the same email as logged in user
                    }
                } else {
                    vm.setDefaultMainPrincipalIfNecessary()
                }
                vm.is_signatory_required = vm.IsPrincipalRoleRequired(vm.PRINCIPAL_ROLES.AUTHORISED_SIGNER);
            },
            toggleBeneficialOwner: function ($event, beneficial_owner_index) {
                let vm = this;
                vm.is_beneficial_owner_required = vm.IsPrincipalRoleRequired(vm.PRINCIPAL_ROLES.BENEFICIAL_OWNER);
            },
            toggleResponsibleParty: function ($event, responsible_party_owner_index) {
                let vm = this;
                vm.is_responsible_party_required = vm.IsPrincipalRoleRequired(vm.PRINCIPAL_ROLES.RESPONSIBLE_PARTY);
            },
            toggleIsDirector: function ($event, director_index) {
                let vm = this;
                vm.is_director_required = vm.IsPrincipalRoleRequired(vm.PRINCIPAL_ROLES.DIRECTOR);
            },
            checkPrincipalDocument: function (owner) {
                if (!this.merchant.hasOwnProperty('documents') || this.merchant.documents.length < 1 || !owner)  return true;

                const { owner_ref } = owner;
                const { documents } = this.merchant;
                const ownerDocuments = documents.filter(doc => doc.entity_id === owner_ref);
                let owner_name = (owner.owner_first_name && owner.owner_surname) ? owner.owner_first_name + ' ' + owner.owner_surname : this.lang('principal');

                if (ownerDocuments.length > 0) {
                    this.notifyError(this.lang('error'), this.lang('principal_has_document_error').replace('{0}', owner_name));
                    return false;
                }

                return true;
            },

            setDefaultMainPrincipalIfNecessary: function () {
                // If everything is 0, set the first principal to be the main principal  and signatory
                const no_main_principal = this.owners.every((obj) => {
                    return obj.is_main_principal === '0'
                });
                if (no_main_principal) {
                    this.owners[0]['is_main_principal'] = '1';
                    this.owners[0]['is_signatory'] = '1'; //set
                }
            },
            editPrincipalAddress: function (contact) {
                ////console.log(contact.edit_address);
                //incase the edit adddress is true turn it false then true
                if (!!contact.edit_address) {
                    contact.edit_address = false;
                }

                contact.edit_address = true;
            },
            searchPersonnel(index) {
                this['current_index'] = index;
                // this['personnel_mode'] = this.personnel_mode.shareholder;
                if (this.getIso3FromCountryCode(this.merchant.registration_address.country_code) === 'POL') {
                    if(!!this.merchant.tax_id){
                        this.searchByVatNumber()
                    }
                    else if(this.merchant.ownership_entity_type === this.business_types.SOLE_TRADER){
                        this.searchByVatNumber();
                    }
                    else {
                        this.searchByLegalName();
                    }
                } else if (!!this.merchant.reg_number) {
                    this.searchByRegNumber()
                } else {
                    this.searchByLegalName();
                }
            },
            //TODO when a new principal is added do not show the previous address button until the date from field is filled
            principalAddress: function (principal, index, contact_index, element) {
                // this.removeAddressSlashes(principal, index, contact_index, element);
                // principal['address_complete'] = this.hasCompleteAddresses(principal);
                let regex = /[/]/g;
                principal.contacts[0][element] = principal.contacts[0][element].replace(regex, '-');
                principal['address_complete'] = true;
            },
            checkCompleteAddresses: function () {
                let vm = this;
                vm.owners.forEach((obj) => {
                    vm.principalAddress(obj);
                })
            },
            hasCompleteAddresses: function (owner) {
                // Complete address >= 3 years
                //the original design puts owner.address_date_from at the value of date_from component. Changed to owner.contacts[0].date_from
                owner.address_date_from = owner.contacts[0].date_from;
                owner.contacts[0].date_to = null;

                //get the interval between first address to today
                let vm = this, three_years = 1095;
                //add up the interval of each address between date_from to date_to.
                let interval = 0;
                let invalid_date = false;
                if (owner.contacts.length > 0) {
                    owner.contacts.forEach((obj) => {
                        interval += vm.returnDifferenceBetweenUKDates(obj.date_from, obj.date_to);
                    })
                    if (!owner.contacts[owner.contacts.length - 1].date_from) {
                        invalid_date = true;
                    }
                }

                //if invalid_date, just return ''
                return invalid_date ? '' : interval >= three_years;
            },
            canAddPrincipal: function () {
                if (this.merchant.ownership_entity_type === this.business_types.SOLE_TRADER) {
                    return this.owners.length < 1;
                } else {
                    return true;
                }
            },
            // savePrincipals: function (next_tab = false) {
            //     if (next_tab){
            //         this.$router.push({path: this.nextTabRoute()})
            //     }
            // },
            // nextTabRoute: function () {
            //     let path = '/application/add/outlets/';
            //
            //     return path;
            // }
            getPrincipalLogicConfigByOwnershipType: function() {
                let vm = this;
                let has_principal_logic_param = this.parameters
                    && vm.npPropertyExistAndIsArray(vm.parameters, 'PRINCIPAL_LOGIC_PARAM');
                let principal_logic_rules = has_principal_logic_param ? vm.parameters.PRINCIPAL_LOGIC_PARAM : [];
                principal_logic_rules = principal_logic_rules.filter(rule => {
                    return rule.ownership_entity_type === vm.merchant.ownership_entity_type &&
                        rule.assisted_boarding === '1'
                });
                return principal_logic_rules;
            },
            disableByBankId: function (owner) {
                return (owner.is_bank_id_verified == '1') && this.isBankIdValidation(owner);
            },
            isBankIdValidation: function (owner) {
                return owner.verification_type.includes(this.PRINCIPAL_VALIDATION_TYPE.BANK_ID);
            },
            checkSetMainPrincipal: function () {
                return false;
            },
            checkSetOwner: function (owner) {
                owner.is_owner = '1';
                return false;
            },
            onCloseToggleShowedRequiredDocumentsList: function () {
                this.showed_required_documents_list = false;
            },
            getAllowedIso3Search: function (page = 'default') {
                if (this.allowed_iso3_search[page]) {
                    return this.allowed_iso3_search[page];
                }
                return this.allowed_iso3_search['default'];
            },
            resetPageConfig: function () {
                const vm = this;
                const appStore=useModuleStore();
                appStore.commit(types.TOGGLE_LOADING, true);
                setTimeout(function() {
                vm.runPageConfig(vm.pageConfig);
                appStore.commit(types.TOGGLE_LOADING, false);
                }, 500);
            },
          isOwnerMfaEditable: function(owner){
              //todo: work on this logic when core MFA functions are enabled
            //check the RACI business_contacts as the main principal
            let main_merchant_user = this.merchant.business_contacts.find(obj => obj.contact_type === 'RACI');
            const is_main_owner = (!!main_merchant_user && !!main_merchant_user.business_contact_email &&
                ( owner.owner_email === main_merchant_user.business_contact_email))
            //account for the config is signatory condition
            return (is_main_owner && owner.is_signatory === '1')
          },
        },
        watch: {
            'merchant.ownership_entity_type': {
                deep:true,
                handler: function (val, oldVal){
                    if (this.isSoleTrader){
                       this.setSoleTraderPrincipal();
                    }
                    this.setPrincipalLogicRules();
                },
                immediate: true
              //Run the watcher while the page is loading
            }
        }

    }
</script>

<style scoped>

    .specific-blue-color {
        background-color: #2C7BBC !important;
    }

    .black-text-color {
        color: #000000 !important;
    }

    .btn-required-document {
        font-weight: bold !important;
        color: #2C7BBC !important;
        background-color: #FFFFFF !important;
        box-shadow: 0 0 0 1px rgba(44, 123, 188, 0.3) inset !important;
        border: 1px solid #2C7BBC !important;
    }

    .btn-required-document:hover,
    .btn-required-document:focus {
        box-shadow: 0 0 0 40px rgba(44, 123, 188, 0.2) inset !important;
        background-position: 0 0  !important;
        background-image: none !important;
    }

</style>
